import moment from 'moment';
import React from 'react';
import { Button, Card, CardBody, Col, Row, Table } from 'react-bootstrap';
import { CaretDownFill, CaretUpFill, PlusCircleFill, XLg } from 'react-bootstrap-icons';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { ProfileService } from '../../services/ProfileService';
import { ownSubscribe, sendMessage, unSubscribe } from '../../stomp/StompSocket';
import * as BullCache from "../../util/BullCache";
import { StyleConstant } from '../../util/StyleConstant';
import AddOrder from './AddOrder';
import './Watch.css';
import PubSub from 'pubsub-js';
import {showToast} from "../../util/Utils"
import { AdminService } from '../../services/AdminService';

var allScripts = BullCache.getFromCache('allScripts');
var watchScripts = [];
var user = BullCache.getFromCache('user');
const customOrder = ["NSE", "MCX", "NCDEX", "BSE"];

class Watch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      indexData: {},
      mkw: {},
      segments: null,
      first: true,
      indexFirst: true,
      show: false,
      redirect: undefined,
      market: [],
      scripts: [],
      expiry: [],
      selectedScript: '',
      loading : true,
      isConnected: false,
      called : false,
      selectedMarket: null,
      selectedSymbol: null,
      selectedExpiry: null,
    }
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidMount() {
    
    this.setState({ first: true });
    
    var mar = [];
    Object.keys(allScripts).map(function (key) {
      mar.push({ value: key, label: key });
    });
    this.setState({ market: mar });

    user.profile?.scripts?.map((pf, index) => {
      watchScripts.push(pf);
    });


     
    this.token = PubSub.subscribe("eventConnected", (msg, data) => {
      this.setState({ isConnected: true }); 
      if(!this.state.called) {
        this.setState({ called: true }); 
        this.subscribeWatch(this); 
      }
    }); 

    this.token1 = PubSub.subscribe("eventDisconnected", (msg, data) => {
      this.setState({ isConnected: false, called: false }); 
      try { unSubscribe('watch-subscribe-id'); } catch (e) { }
      try { unSubscribe('index-subscribe-id'); } catch (e) { }
      try { unSubscribe('update-subscribe-id'); } catch (e) { }
      try { unSubscribe('update-script-id'); } catch (e) { }
    }); 

    this.token2 = PubSub.subscribe("subFailed", (msg, data) => {
      this.setState({ isConnected: false, called: false }); 
    }); 
    
    if(!this.state.called) {
      this.setState({ called: true }); 
      this.subscribeWatch(this); 
    }
  }

  componentWillUnmount() {
      PubSub.unsubscribe(this.token);
      PubSub.unsubscribe(this.token1);
      PubSub.unsubscribe(this.token2);
      this.cleanupSubscriptions();
  }

   cleanupSubscriptions  = () => {
    try { unSubscribe('watch-subscribe-id'); } catch (e) { }
    try { unSubscribe('index-subscribe-id'); } catch (e) { }
    try { unSubscribe('update-subscribe-id'); } catch (e) { }
    try { unSubscribe('update-script-id'); } catch (e) { }
  }

  sortList = (list) => {
    return list.sort((a, b) => customOrder.indexOf(a.e) - customOrder.indexOf(b.e));
  };

  subscribeWatch(comp) {

    ownSubscribe('/topic/watch/'+user.adminId, function (msg) {
     
      if (msg.body) {
        if (comp.state.first) {
          comp.setState({ loading: false});
          comp.setState({ first: false });
          var segments = [];
          var scriptMap = JSON.parse(msg.body).reduce(function (map, obj) { 
            if (obj !== undefined && obj !== null && obj.ix !== undefined) {
                var ix = moment(obj.ix, 'DD/MM/YYYY', true);
                
                if (ix.isValid()) {
                    obj["ix"] = ix.format("DDMMMYYYY").toUpperCase();
                    map[obj.sn] = obj;
        
                    const isPresent = segments.some(segment => segment.e === obj.e);
                    if (!isPresent) {
                        segments.push({ e: obj.e, collapse: true });
                    }
                } 
            }
            return map; // Always return the map
          }, {});
          
          if(Object.keys(scriptMap).length > 0) {
            comp.setState({ data: {} });
            comp.setState({ data: scriptMap });
            comp.setState({segments:[]});
            comp.setState({segments: comp.sortList(segments)});
          }

        } else {
          if (Object.keys(comp.state.data).length > 0) {
            var column = [2, 4, 6, 9, 10, 11, 12, 19, 20, 8]
            var scriptMap = comp.state.data;
            JSON.parse(msg.body).forEach(script => {
              
              var scriptExisting = scriptMap[script.sn];
              if (scriptExisting !== undefined) {
                  column.forEach(num => {
                  var i = "i" + num;
                  var si = "si" + num;
                  if (script[i] !== undefined && script[i] !== undefined) {
                    scriptExisting[i] = script[i];
                    scriptExisting[si] = script[si];
                  } else {
                    scriptExisting[si] = 2;
                  }
                });
                scriptMap[script.sn] = scriptExisting;
              }
            });
            comp.setState({ data: scriptMap });
          }
        }
      }
    }, 'watch-subscribe-id');

    ownSubscribe('/topic/index/'+user.adminId, function (msg) {
    
      if (msg.body) {
        var obj = JSON.parse(msg.body);
        if (comp.state.indexFirst) {
          comp.setState({ indexFirst: false });
          comp.setState({ indexData: {} });
          comp.setState({ indexData: obj });
        } else {
          if (Object.keys(comp.state.indexData).length > 0) {
            const updatedIndexData = { ...comp.state.indexData };
             Object.entries(comp.state.indexData).map(([key1, value1]) => {
                Object.entries(obj).map(([key, value]) => {
                if(key1 === key ){
                  updatedIndexData[key1]  = value;
                }
              });
            });
           comp.setState({ indexData: updatedIndexData });
          }
        }
      }
    }, 'index-subscribe-id');

    ownSubscribe('/topic/session/'+user.adminId, function (msg) {
    
      if (msg.body) {
        
        const decodedString = atob(JSON.parse(msg.body).payload);
        var obj = JSON.parse(decodedString);
        
        if(obj?.code == 1){
          var trade = obj.data.trade;
          Swal.fire({
            title: `<small>${trade.orderType.split("-")[0] + " Order "+ trade.status}</small>`,
            width: 480,
            icon: "success",
            color: "#fff",
            background: "#000",
            html: `
              <Table style="width:100%;"><thead></thead><tbody>
                <tr><td style="color:#fff !important; text-align:left; padding-left: 22%;">${trade.segment + " " + trade.symbol}</td> <td style="color:#fff !important; text-align:left">${trade.expiry}</td></tr>
                <tr><td style="color:#fff !important; white-space: nowrap; text-align:left; padding-left: 15%;">Lot:</td> <td style="color:#fff !important; text-align:left">${trade.lot}</td></tr>
                <tr><td style="color:#fff !important; text-align:left; padding-left: 22%;">Quantity:</td> <td style="color:#fff !important; text-align:left">${trade.quantity}</td></tr>
                <tr><td style="color:#fff !important; text-align:left; padding-left: 22%;">OrderType:</td> <td style="color:#fff !important; text-align:left">${trade.orderType.includes("MP") ? "Market" : "Limit"}</td></tr>
                <tr><td style="color:#fff !important; text-align:left; padding-left: 22%;">Price:</td> <td style="color:#fff !important; text-align:left">${trade.netRate}</td></tr>
                </tbody>
              </Table>
            `,
            showCloseButton: true,
            focusConfirm: true,
            confirmButtonText: `OK`,
            timer: 1500
          });
        }
       
      }
    }, 'update-subscribe-id');

    ownSubscribe('/app/topic/profile/removescript/'+user.adminId, function (msg) {
      //console.log("script removed");
    });
  
    sendMessage('/app/topic/watch/'+user.adminId,
      JSON.stringify(prepareFirstTimeRequest(watchScripts)));
      this.setState({ loading: watchScripts.length === 0 ? false : true  });

    function prepareFirstTimeRequest(scripts) {
      return {
        'scripts': scripts, isMobile: true, data: {}, wantToStop: false, wantToRemoveScripts: false
      };
    }

    ownSubscribe('/topic/script/update/'+user.adminId, function (msg) {
      if(msg?.body && msg?.body === 'true'){
          AdminService.getAdminScripts({ adminId: user.adminId, loginId: user.adminId })
        .then((resp) => {
          if (resp.code === 1 && resp.data.allScripts) {
            BullCache.saveToCache("allScripts", resp.data.allScripts);
            allScripts = resp.data.allScripts;
              var mar = [];
              Object.keys(allScripts).map(function (key) {
                mar.push({ value: key, label: key });
              });
              comp.setState({ market: mar });
          }
        })
        .catch((error) => {
          console.error("Error fetching scripts:", error);
        });
      }
    }, 'update-script-id');

  }

  toAddScr = (e) => {
    if(this.state.selectedScript){
      
        sendMessage('/app/topic/watch/'+user.adminId,
              JSON.stringify({ 'scripts': [], isMobile: true, data: {}, wantToStop: false, wantToRemoveScripts: true }));

        ProfileService.addScript({'adminId':user.adminId,'scriptId':this.state.selectedScript}).then(res => {
          if(res?.code == 1) {
           
            watchScripts.push(this.state.selectedScript);
            sendMessage('/app/topic/watch/'+user.adminId,
              JSON.stringify({ 'scripts': watchScripts, isMobile: true, data: {}, wantToStop: false, wantToRemoveScripts: false }));
            if (Array.isArray(user.profile?.scripts)) {
              user.profile.scripts.push(this.state.selectedScript);
            } else {
              user.profile.scripts = [this.state.selectedScript];
            }

            this.setState({ first: true });
            showToast("success", "Added to watchlist");
            BullCache.saveToCache("user", user);
          }
        });;
    }
  }

  showModal = (mkw1) => {
    if(user.adminType !== 'SUBBROKER'){
      this.setModalData(mkw1);
      this.setState({ show: true });
    }
  };

  setModalData = (mkw1) => {
    if (mkw1 !== undefined) {
      this.setState({ mkw: mkw1 });
    }
  }

  hideModal = () => {
    this.setState({ show: false });
  };

  exchangeChange = (e) => {
    this.setState({
      selectedMarket: e,
      selectedSymbol: null,
      selectedExpiry: null,
      scripts: [],              // reset SCRIPT NAME dropdown
      expiry: [],               // reset EXPIRY DATE dropdown
    });

    var scr = [];

    Object.keys(allScripts[e.value]).map(function (key2) {
      scr.push({ value: allScripts[e.value][key2], label: key2 });

    });
    this.setState({ scripts: scr });
  };

  scriptChange = (e) => {
     this.setState({
      selectedSymbol: e,
      selectedExpiry: null,
      expiry: [],               // reset EXPIRY DATE dropdown
    });

    var scr = [];
    e.value.forEach((elm, idx) => {
      if(!elm.sn.split('#')[2].includes("2050")) {
        var ix = moment(elm.sn.split('#')[2], 'DD/MM/YYYY', true);
        if (ix.isValid()) {
          scr.push({ value: elm, label: ix.format("DDMMMYYYY").toUpperCase() });
        }
      }
    });

    this.setState({ expiry: scr });
  }

  selectScript = (e) => {
     this.setState({
      selectedExpiry: e,
      expiry: [],               // reset EXPIRY DATE dropdown
    });
    this.setState({ selectedScript: e.value.id });
  }

  toggleCollapse = (mkw1) => {
    this.setState(prevState => ({
      segments: prevState.segments.map(segment => 
        segment.e === mkw1.e ? { ...segment, collapse: !segment.collapse } : segment
      )
    }));
  };

  removeScript = (scriptId) => {

    Swal.fire({
              text: 'Are you sure you want to remove script?',
               icon: 'warning',
               showCancelButton: true,
               confirmButtonText: 'Yes ',
               cancelButtonText: 'No',
               cancelButtonColor: "#d33",
               confirmButtonColor: "#0C51C4",
           }).then((result) => {
               if (result.isConfirmed) {

                 sendMessage('/app/topic/watch/'+user.adminId,
                                          JSON.stringify({ 'scripts': [], isMobile: true, data: {}, wantToStop: false, wantToRemoveScripts: true }));
                                          
                ProfileService.removeScript({'adminId':user.adminId,'scriptId':scriptId})
                                .then((res) => {
                                  this.setState({ loading: false});
                                    if (res.code === 1) {
                                      
                                       showToast("success", "Script Removed");

                                        this.setState({ first: true });
                                        watchScripts = [...new Set(watchScripts.filter(script => script !== scriptId))];
                                        
                                        sendMessage('/app/topic/watch/'+user.adminId,
                                          JSON.stringify({ 'scripts': watchScripts, isMobile: true, data: {}, wantToStop: false, wantToRemoveScripts: false }));
                                     
                                        user.profile.scripts = [...new Set(user.profile.scripts.filter(script => script !== scriptId))];
                                        BullCache.saveToCache("user", user);
                                    }
                                }) .catch((error) => {
                                 
                                  Swal.fire({
                                    icon: 'error',
                                    text: error?.response?.data?.data?.errors[0]?.errorMessage || "General system error!"
                                  });
                                });;
               }
             });
  };

  render() {
    const { segments, loading } = this.state;

    return (

      <>
        <Card>
          <CardBody className='p-1'>
            <Card className='card-background'>
              <CardBody>
                <Row>
                  <Col xl={2} md={2}><label className='fss-09'>MARKET</label><br /><Select options={this.state.market} theme={StyleConstant.the} styles={StyleConstant.customStyles} onChange={e => this.exchangeChange(e)} value={this.state.selectedMarket}/></Col>
                  <Col xl={2} md={2}><label className='fss-09'>SCRIPT NAME</label><br /><Select options={this.state.scripts} theme={StyleConstant.the} styles={StyleConstant.customStyles} onChange={e => this.scriptChange(e)}  value={this.state.selectedSymbol}/></Col>
                  <Col xl={2} md={2}><label className='fss-09'>EXPIRY DATE</label><br /><Select options={this.state.expiry} theme={StyleConstant.the} styles={StyleConstant.customStyles} onChange={e => this.selectScript(e)}  value={this.state.selectedExpiry}/> </Col>
                  <Col xl={3} md={2}><Button variant='success' className='mt-3' onClick={e => this.toAddScr()}><PlusCircleFill /> Add</Button></Col>
                  
                  <Col xl={3} xs={3} md={4} className=" ">
                        {Object.entries(this.state.indexData).map(([key, value]) => {
                          
                          return (<Row className="g-0">
                            <Col xl={5} md={5} className="pt-1 fss-09 text-end">{key.split('#')[1]} :</Col>
                            <Col xl={3} md={3} className="pt-1 text-end fss-09">&nbsp;{parseFloat(value.i6).toFixed(2)}</Col>
                            <Col xl={3} md={3} className="p-0 mt-1 text-start fss-09"> {value.i19 >=0 ? <CaretUpFill style={{ color: 'green' }} /> : <CaretDownFill style={{ color: 'red' }} />} {parseFloat(value.i19).toFixed(2)}</Col>
                          </Row> 
                        );
                        })}
                  </Col>                
                </Row>
              </CardBody>
            </Card>

            <Card className='mt-1 mb-4'>
              <Card.Body className='p-0'>
                {this.state.first ?
                 loading ?
                  <div className="container vh-100">

                    <div className="d-flex align-items-center justify-content-center h-90">
                      <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>  :  <div className='mt-2 ms-1'>No script available!</div>
                  : <div>
                    {Object.entries(segments).map(([key1, mkw1]) => (
                  <Table hover responsive className='mb-1'>
                    <thead className='bg-secondary-row'>
                      <tr>
                        <th style={{ width: '20rem'}}> {mkw1.collapse ? <CaretDownFill size={20} onClick={()=> this.toggleCollapse(mkw1)}/> : <CaretUpFill size={20} onClick={()=> this.toggleCollapse(mkw1)}/>} &nbsp;{mkw1.e}</th>
                        <th style={{ width: '10rem'}} className='text-center'>BID RATE</th>
                        <th style={{ width: '10rem'}} className='text-center'>ASK RATE</th>
                        <th style={{ width: '10rem'}} className='text-center'>LTP</th>
                        <th style={{ width: '6rem'}} className='text-end'>CHANGE(%)</th>
                        <th style={{ width: '6rem'}} className='text-end'>NET CHANGE</th>
                        <th style={{ width: '6rem'}} className='text-end'>HIGH</th>
                        <th style={{ width: '6rem'}} className='text-end'>LOW</th>
                        <th style={{ width: '6rem'}} className='text-end'>OPEN</th>
                        <th style={{ width: '6rem'}} className='text-end'>CLOSE</th>
                        <th style={{ width: '5rem'}} className='text-center'>REMOVE</th>

                      </tr>
                    </thead>
                    {mkw1.collapse ? (
                    <tbody>
                      {Object.entries(this.state.data).map(([key, mkw]) => (
                        mkw.e === mkw1.e ? (
                        <tr key={mkw.id} className='market-highlight-row pt-0 pb-0'>
                          <td className='watch-text p-1'> {' ' + mkw.e} {mkw.s} {mkw.ix}</td>
                          <td onClick={e => this.showModal(mkw)} className='p-0'> <div className={mkw.si2 === '1' ? "red-c" : "blue-c"} >{parseFloat(mkw.i2).toFixed(2)}</div></td>
                          <td onClick={e => this.showModal(mkw)} className='p-0'> <div className={mkw.si4 === '1' ? "red-c" : "blue-c"} >{parseFloat(mkw.i4).toFixed(2)}</div></td>
                          <td className='p-0'> <div className={mkw.si6 === '1' ? "red-c" : "blue-c"} >{parseFloat(mkw.i6).toFixed(2)}</div></td>
                          <td className='text-end watch-text p-0 pe-2'>{parseFloat(mkw.i20).toFixed(2)}</td>
                          <td className='text-end watch-text p-0 pe-2'>  {mkw.i19 < 0 ? <CaretDownFill style={{ color: 'red' }} /> : <CaretUpFill style={{ color: 'green' }} />} {parseFloat(mkw.i19).toFixed(2)}</td>
                          <td className='text-end watch-text p-0 pe-2'>{parseFloat(mkw.i9).toFixed(2)}</td>
                          <td className='text-end watch-text p-0 pe-2'>{parseFloat(mkw.i10).toFixed(2)}</td>
                          <td className='text-end watch-text p-0 pe-2'>{parseFloat(mkw.i11).toFixed(2)}</td>
                          <td className='text-end watch-text p-0 pe-2'>{parseFloat(mkw.i12).toFixed(2)}</td>
                          <td className='p-0' style={{ textAlign: 'center' }}> <XLg color='red' onClick={e => this.removeScript(mkw.id)} style={{cursor: 'pointer'}}/></td>
                        </tr>
                        ) : null
                      ))}
                    </tbody>) : null}
                  </Table>
                    ))}
                  </div>
                }

              </Card.Body>
            </Card>
          </CardBody>
        </Card>

        <AddOrder onHide={this.hideModal} show={this.state.show} mkw={this.state.mkw} isBuy={true} />
      </>
    )
  }
}
export default Watch;